import "./GetInTouch.module.css";
import GatewayNavigation from "@/reusable_sections/Header";
import LetsStartYourTransformation from "./sections/LetsStartYourTransformation";
import TheUrbanLocation from "./sections/TheUrbanLocation";
import Footer from "@/reusable_sections/Footer";
export default function GetInTouchPage() {
  return <div>
      <GatewayNavigation />
      <LetsStartYourTransformation />
      <TheUrbanLocation />
      <Footer />
    </div>;
}